import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';

export class CustomValidator {
  static matchesPassword: any = (form: FormGroup) => {
    const password = form.get('password');
    const repeatPassword = form.get('repeatPassword');
    if (!password || !repeatPassword) return null;

    if (password.value && repeatPassword.value && password.value !== repeatPassword.value) {
      repeatPassword.setErrors({ equalsPassword: true });
      return { equalsPassword: true };
    } else {
      return null;
    }
  };

  static validateAge: any = (form: FormGroup) => {
    const birthdate = form.get('birthdate');
    if (!birthdate || !birthdate.value) return null;

    const luxonBirthdate = DateTime.fromFormat(birthdate.value, 'yyyy-LL-dd');
    const yearsDiff = Math.abs(luxonBirthdate.diffNow('years').years);
    if (birthdate.value && luxonBirthdate && (yearsDiff < 14 || yearsDiff > 100)) {
      birthdate.setErrors({ invalidAge: true });
      return { invalidAge: true };
    } else {
      birthdate.setErrors(null);
      return null;
    }
  };

  static sameEmails: any = (form: FormGroup) => {
    const email = form.get('email');
    const repeatEmail = form.get('repeatEmail');
    if (!email || !repeatEmail) return null;

    if (email.value !== repeatEmail.value) {
      repeatEmail.setErrors({ differentEmails: true });
      return { differentEmails: true };
    } else {
      repeatEmail.setErrors(null);
      return null;
    }
  };

  static dateIsBetween = (beforeDate: string, afterDate: string): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      if (
        DateTime.fromFormat(control.value, 'yyyy-LL-dd') < DateTime.fromFormat(beforeDate, 'yyyy-LL-dd') ||
        DateTime.fromFormat(control.value, 'yyyy-LL-dd') > DateTime.fromFormat(afterDate, 'yyyy-LL-dd')
      ) {
        return { min: beforeDate, max: afterDate };
      } else {
        return null;
      }
    };
  };

  static hasCorrectSelection =
    (correctSelection: string): ValidatorFn =>
    (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value && value !== correctSelection) {
        return { correctSelection: true };
      }
      return null;
    };

  static cannotContainSpace: any = (control: AbstractControl): ValidationErrors | null => {
    if (!control?.value) return null;

    if ((control.value as string).indexOf(' ') > -1) {
      return { cannotContainSpace: true };
    }

    return null;
  };

  static validateDateBefore: any = (form: FormGroup) => {
    const startDate = form.get('startDate');
    const endDate = form.get('endDate');
    if (!startDate || !endDate) return null;

    if (startDate.value && endDate.value && DateTime.fromFormat(endDate.value, 'yyyy-LL-dd') < DateTime.fromFormat(startDate.value, 'yyyy-LL-dd')) {
      endDate.setErrors({ dateIsBefore: true });
      return { dateIsBefore: true };
    } else {
      return null;
    }
  };
}
